<script>
    import Sunny from './Sunny.svelte'
    import PartlySunny from './PartlySunny.svelte'
    import Cloudy from './Cloudy.svelte'
    
    export let coverage;
</script>

<div>
    {#if coverage < 25}
      <Sunny />
    {:else if coverage < 50}
      <PartlySunny />
    {:else}
      <Cloudy />
    {/if}
    <p>{coverage}%</p>
</div>